import { createAsyncThunk } from "@reduxjs/toolkit";
import config from "../../config";
import axiosClient from "../../common/api/request";

export const getSalarySettings = createAsyncThunk(
  "get_salary_settings",
  async (params, { rejectWithValue }) => {
    try {
      const data = await axiosClient.get(
        `${config.API_URL}/salary_settings/`,
        { params },
        config
      );
      return data;
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        typeof error.response.data === "object"
      ) {
        // [CANA-589] the status lets the tab tell a 403 (no
        // view_salarysetting) apart from a validation body.
        return rejectWithValue({
          ...error.response.data,
          status: error.response.status,
        });
      } else {
        return rejectWithValue({
          Error: error.message,
        });
      }
    }
  }
);

export const patchSalarySettings = createAsyncThunk(
  "patch_salary_settings",
  async (params, { rejectWithValue }) => {
    try {
      const data = await axiosClient.patch(
        `${config.API_URL}/salary_settings/`,
        params,
        config
      );
      return data;
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        typeof error.response.data === "object"
      ) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue({
          Error: error.message,
        });
      }
    }
  }
);
